<script>
import MainContainer from '@/components/container/MainContainer.vue';
import LeftPanel from '@/components/container/LeftPanel.vue';
import RightContainer from '@/components/container/RightContainer.vue';

import ButtonReturn from '@/components/left-panel/unique-buttons/ButtonReturn.vue';
import ButtonAnyNew from '@/components/left-panel/any-button/ButtonAnyNew.vue';
import ToggleButton from '@/components/left-panel/any-button/ToggleButton.vue';

import PlanList from '@/components/page-billing/PlanList.vue';
import PlanAdd from '@/components/page-billing/PlanAdd.vue';
import PlanEdit from '@/components/page-billing/PlanEdit.vue';
import RefundList from '@/components/page-billing/RefundList.vue';
import RefundReview from '@/components/page-billing/RefundReview.vue';

import { promiseAll, calculatePromise } from '@/api/default.js';
import constants from '@/constants';

export default {
    data() {
        return {
            constants: constants,
            activeTab: 'plans', // 'plans' or 'refunds'
            planTypeFilter: 'all', // 'all', 'personal', or 'corporate'
        };
    },
    components: {
        MainContainer,
        LeftPanel,
        RightContainer,
        ButtonReturn,
        ButtonAnyNew,
        ToggleButton,
        PlanList,
        PlanAdd,
        PlanEdit,
        RefundList,
        RefundReview,
    },
    async mounted() {
        this.$store.commit('IS_LOAD', true);

        const promiseList = await calculatePromise([
            { dispatch: 'loadBillingPlans', commit: null, isArray: false },
            { dispatch: 'loadRefunds', commit: null, isArray: false },
        ]);
        await promiseAll(promiseList);

        this.$store.commit('IS_LOAD', false);
    },
    computed: {
        includeInactive() {
            return this.$store.getters.INCLUDE_INACTIVE_PLANS;
        },
        filteredPlans() {
            const plans = this.$store.getters.BILLING_PLANS || [];
            if (this.planTypeFilter === 'all') {
                return plans;
            }
            return plans.filter(
                (plan) => plan.plan_type === this.planTypeFilter
            );
        },
    },
    methods: {
        togglePlanAdd() {
            this.$store.commit(
                'IS_SHOW_PLAN_ADD',
                !this.$store.getters.IS_SHOW_PLAN_ADD
            );
        },
        async toggleIncludeInactive() {
            this.$store.commit(
                'SET_INCLUDE_INACTIVE_PLANS',
                !this.includeInactive
            );
            await this.$store.dispatch('loadBillingPlans');
        },
        getPlanTypeBadge(planType) {
            if (planType === 'personal') {
                return {
                    text: 'Personal',
                    class: 'badge_personal',
                };
            } else if (planType === 'corporate') {
                return {
                    text: 'Corporate',
                    class: 'badge_corporate',
                };
            }
            return {
                text: 'Unknown',
                class: 'badge_unknown',
            };
        },
    },
};
</script>

<template>
    <PlanAdd />
    <PlanEdit />
    <RefundReview />

    <MainContainer>
        <LeftPanel>
            <ButtonReturn />
            <hr class="left-separator" />

            <label class="chapter_header">Subscription Plans:</label>
            <ButtonAnyNew title="New Plan" :method="togglePlanAdd" />
            <ToggleButton
                v-if="activeTab === 'plans'"
                title="Show Inactive Plans"
                :toggle="includeInactive"
                :method="toggleIncludeInactive"
            />

            <hr class="left-separator" v-if="activeTab === 'plans'" />

            <label class="chapter_header" v-if="activeTab === 'plans'"
                >Filter by Type:</label
            >
            <select
                v-if="activeTab === 'plans'"
                v-model="planTypeFilter"
                class="filter_dropdown"
            >
                <option value="all">All Types</option>
                <option value="personal">Personal</option>
                <option value="corporate">Corporate</option>
            </select>

            <hr class="left-separator" />

            <label class="chapter_header">View:</label>
            <button
                @click="activeTab = 'plans'"
                :class="{ active: activeTab === 'plans' }"
                class="left_button_main_container"
            >
                <label class="cursor_pointer">Plans</label>
            </button>
            <button
                @click="activeTab = 'refunds'"
                :class="{ active: activeTab === 'refunds' }"
                class="left_button_main_container"
            >
                <label class="cursor_pointer">Refunds</label>
            </button>
        </LeftPanel>

        <RightContainer>
            <PlanList
                v-if="activeTab === 'plans'"
                :filteredPlans="filteredPlans"
                :getPlanTypeBadge="getPlanTypeBadge"
            />
            <RefundList v-else-if="activeTab === 'refunds'" />
        </RightContainer>
    </MainContainer>
</template>

<style scoped>
.left_button_main_container.active {
    background-color: var(--main-color);
    color: white;
}

.filter_dropdown {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid var(--border-color);
    border-radius: 4px;
    background: var(--background-color);
    color: var(--text-color);
    font-size: 14px;
    cursor: pointer;
    transition: border-color 0.2s ease;
}

.filter_dropdown:hover {
    border-color: var(--primary-color);
}

.filter_dropdown:focus {
    outline: none;
    border-color: var(--primary-color);
}
</style>
